import { api } from './api';

export interface RoleAssignmentPayload {
  role: string;
  school_id: string | null;
  school_name: string | null;
}

/* CLEAN-ARCH (Vague 4) : rôles du caller via le port tRPC (scopé server-side), */
/* au lieu de supabase-js direct. userId conservé pour la signature, ignoré. */
export async function fetchUserRoles(_userId: string): Promise<string[]> {
  return api.roles.list.query();
}

/** Un item par role_assignment distinct (teacher/direction/tutor multi-école). */
export async function fetchRoleAssignments(_userId: string): Promise<RoleAssignmentPayload[]> {
  return api.roles.listAssignments.query();
}
